import { observer } from 'mobx-react';
import { ReactNode } from 'react';

interface ModalTitleProps {
  title: ReactNode;
  className?: string;
}

function ModalTitle({ className, title }: ModalTitleProps) {
  return (
    <h2 className={className} data-test-modal-title={true}>
      {title}
    </h2>
  );
}

export default observer(ModalTitle);
